/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import DropDownMenu, { DropDownMenuProps } from './DropDownMenu';
import { ICustomElement, noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-dropdown-menu': Partial<HTMLElement> &
        DropDownMenuProps &
        Partial<{ ref: ICustomElement }> & {
          'custom-position-class'?: string;
        };
    }
  }
}

export function defineSolidDropDownMenu(): void {
  customElement(
    'tc-dropdown-menu',
    {
      className: undefined,
      type: undefined,
      anchorText: undefined,
      anchorIcon: undefined,
      customAnchorIcon: undefined,
      customAnchorClassName: undefined,
      anchorStyle: undefined,
      anchorClassName: undefined,
      anchorIconShape: undefined,
      anchorIconPosition: undefined,
      optionsType: undefined,
      dropDownOptions: [],
      iconTooltip: undefined,
      disabledOptionsTooltipTitle: undefined,
      disabledOptionsTooltipClassName: undefined,
      position: undefined,
      iconPosition: undefined,
      showOnScroll: false,
      disabled: false,
      selected: undefined,
      useFixedStyle: false,
      customPosition: false,
      customPositionClass: undefined,
      setWidth: undefined,
      unsetHeight: false,
      addSeparators: undefined,
      addGroupTitles: undefined,
      disabledItem: undefined,
      fabButton: false,
      dontCloseOnClick: false,
      customMenuItemIcon: undefined,
      tooltip: undefined,
      dataCy: undefined,
      isActionAllowed: false,
    },
    (props, { element }) => {
      noShadowDOM();

      function handleMenuOpen(isOpen: boolean): void {
        const evt = new CustomEvent<{ isOpen: boolean }>('menu-open', {
          detail: { isOpen },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleIconClick(): void {
        const evt = new CustomEvent('icon-clicked', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleSelectionChanged(selected: string, index: number): void {
        const evt = new CustomEvent<{ selected: string; index: number }>(
          'selection-changed',
          {
            detail: { selected, index },
            composed: true,
          }
        );
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <DropDownMenu
          className={props.className}
          type={props.type}
          anchorText={props.anchorText}
          anchorIcon={props.anchorIcon}
          customAnchorIcon={props.customAnchorIcon}
          customAnchorClassName={props.customAnchorClassName}
          anchorStyle={props.anchorStyle}
          anchorClassName={props.anchorClassName}
          anchorIconShape={props.anchorIconShape}
          anchorIconPosition={props.anchorIconPosition}
          optionsType={props.optionsType}
          dropDownOptions={props.dropDownOptions}
          iconTooltip={props.iconTooltip}
          disabledOptionsTooltipTitle={props.disabledOptionsTooltipTitle}
          disabledOptionsTooltipClassName={
            props.disabledOptionsTooltipClassName
          }
          position={props.position}
          iconPosition={props.iconPosition}
          showOnScroll={props.showOnScroll}
          disabled={props.disabled}
          selected={props.selected}
          useFixedStyle={props.useFixedStyle}
          customPosition={props.customPosition}
          customPositionClass={props.customPositionClass}
          setWidth={props.setWidth}
          unsetHeight={props.unsetHeight}
          addSeparators={props.addSeparators}
          addGroupTitles={props.addGroupTitles}
          disabledItem={props.disabledItem}
          fabButton={props.fabButton}
          dontCloseOnClick={props.dontCloseOnClick}
          customMenuItemIcon={props.customMenuItemIcon}
          tooltip={props.tooltip}
          dataCy={props.dataCy}
          isActionAllowed={props.isActionAllowed}
          onMenuOpen={handleMenuOpen}
          onIconClick={handleIconClick}
          onSelectionChanged={handleSelectionChanged}
        />
      );
    }
  );
}
